import { useContext } from 'react';
import { GlobalContext, GlobalStore } from '../context/provider';

const useGlobalContext = () => {
  return useContext<GlobalStore>(GlobalContext);
};
export default useGlobalContext;
